// extracted by mini-css-extract-plugin
export default {"nameWithStatus":"ExternalLinksList_nameWithStatus__OUjIj"};